<template>
  <div>
    <div
      role="tablist"
      aria-orientation="horizontal"
      class="inline-flex items-center bg-gray-800 justify-center border rounded-lg p-1 bg-transparent"
    >
      <button
        v-for="(option, index) in options"
        :key="index"
        type="button"
        role="tab"
        :aria-selected="selectedOption === option.id"
        :class="[
          'inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium border rounded-md transition-all duration-200 cursor-pointer border-none bg-transparent',
          selectedOption === option.id
            ? 'shadow-sm bg-black text-white'
            : 'hover:bg-gray-500',
        ]"
        @click="selectOption(option.id)"
      >
        <i :class="option.icon" class="w-4 h-4" />
        {{ option.name }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabsWhatsApp",
  props: {
    options: {
      type: Array,
      default: () => [
        { id: "alert-rules", name: "Alert Rules", icon: "icon-settings" },
        { id: "alert-history", name: "Alert History", icon: "icon-timer" },
        { id: "recipients", name: "Recipients", icon: "icon-user" },
      ],
    },
    value: {
      type: String,
      default: "alert-rules",
    },
  },
  data() {
    return {
      selectedOption: this.value || "alert-rules",
    };
  },
  watch: {
    value(newValue) {
      if (newValue !== undefined) this.selectedOption = newValue;
    },
  },
  methods: {
    selectOption(optionId) {
      this.selectedOption = optionId;
      this.$emit("input", optionId);
    },
  },
};
</script>
